<script>
// 分级升级培训：完全复用分级单次培训页面，仅培训类型 type=6 不同
import single from '../single/index.vue'

export default {
  name: 'train-single-upgrade',
  extends: single,
  data () {
    return {
      trainType: 6
    }
  }
}
</script>